/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Tokenusagechart_Title2Inputs */

const zh_analytics_tokenusagechart_title2 = /** @type {(inputs: Analytics_Tokenusagechart_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token 用量趋势`)
};

const en_analytics_tokenusagechart_title2 = /** @type {(inputs: Analytics_Tokenusagechart_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token Usage Trend`)
};

const es_analytics_tokenusagechart_title2 = /** @type {(inputs: Analytics_Tokenusagechart_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tendencia de uso de tokens`)
};

/**
* | output |
* | --- |
* | "Token Usage Trend" |
*
* @param {Analytics_Tokenusagechart_Title2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_tokenusagechart_title2 = /** @type {((inputs?: Analytics_Tokenusagechart_Title2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Tokenusagechart_Title2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_tokenusagechart_title2(inputs)
	if (locale === "en") return en_analytics_tokenusagechart_title2(inputs)
	return es_analytics_tokenusagechart_title2(inputs)
});
export { analytics_tokenusagechart_title2 as "analytics_tokenUsageChart_title" }